<template>
    <div>
        <div class="ml-0 mt-3">
            <p class="mt-2 ">Which of these do you have? <strong>(Click all that apply)</strong></p>
        </div>
        <div class="col">
            <!-- <div class="text-with-icon mt-3 border-bottom pb-3 pt-1">
                <svg-icon aria-labelledby="car icon" v-if="!this.form.has_car_access" :name="this.brand+ '/car'" width="40" height="40"></svg-icon>
                <svg-icon aria-labelledby="car selected icon" v-if="this.form.has_car_access" :name="this.brand +'/car-colored'" width="40" height="40"></svg-icon>
                <h2 class="d-inline ml-3">Access to car</h2>
                <div class="custom-control custom-checkbox scale-2 d-inline-block float-right mt-1">
                    <input aria-label="has access to car checkbox" v-model="form.has_car_access" type="checkbox" class="custom-control-input"  id="accessToCarCheckbox" />
                    <label class="custom-control-label" for="accessToCarCheckbox"></label>
                </div>
            </div> -->
            <div class="text-with-icon mt-3 pb-4 pt-2">
                <svg-icon aria-labelledby="bus icon" v-if="!this.form.has_concessionary_pass" :name="this.brand+ '/bus'" width="40" height="auto"></svg-icon>
                <svg-icon aria-labelledby="bus selected icon"  v-if="this.form.has_concessionary_pass" :name="this.brand + '/bus-colored'" width="40" height="auto"></svg-icon>
                <h2 class="d-inline ml-3">Bus pass</h2>
                <div class="custom-control custom-checkbox scale-2 d-inline-block float-right mt-1">
                    <input aria-label="has bus pass check box" v-model="form.has_concessionary_pass" type="checkbox" class="custom-control-input" id="busPassCheckbox" />
                    <label class="custom-control-label" for="busPassCheckbox"></label>
                </div>
            </div>
            <div class="text-with-icon mb-4 mt-3 pb-2 pt-1">
                <svg-icon class="train-svg" aria-labelledby="train selected icon" v-if="this.form.has_railcard" :name="this.brand + '/train-colored'" width="37.5" height="auto"></svg-icon>
                <svg-icon aria-labelledby="train  icon"  v-if="!this.form.has_railcard" :name="this.brand + '/train'" width="38" height="auto"></svg-icon>
                <h2 class="d-inline ml-3">Railcard </h2>
                <div class="custom-control custom-checkbox scale-2 d-inline-block float-right mt-1">
                    <input aria-label="select type of railcard" type="checkbox" class="custom-control-input" v-model="form.has_railcard" @click=" toggleHasRailCard" id="railcardCheckbox" />
                    <label class="custom-control-label" for="railcardCheckbox"></label>
                </div>
                <div v-if="form.has_railcard" class="pb-4 pl-4">
                    <p class="float-left ml-5 pl-3 mr-3" >{{form.railcard}}</p>
                    <p class="pl-5 change-btn" @click="changeRailcard" >Change</p>
                </div>
                <!-- modal -->
                <div tabindex="-1" role="dialog" aria-labelledby="selectRailcardModalLabel" aria-hidden="true">
                    <b-modal ok-only ok-title="Cancel"  size="lg" class="modal-dialog modal-dialog-centered"  ref="railcard-modal" role="document" id="select-railcard-modal" @hidden="onModalClose">
                        <div class="modal-body text-center mb-4">
                            <div class="message pb-4">
                                <h3 class="text-right change-btn"  @click="hideModal">Close</h3>
                                <h1 class="color-secondary-blue">Which railcard do you have?</h1>
                                <p>Please select which of these railcards you have:</p>
                            </div>
                            <div v-for="(type, index) in railcardOptions" :key="index" class="railcard-buttons">
                                <button type='button' @click="selectRailcardType(index)" :class="{'btn-primary': type === form.railcard, 'btn-outline-secondary': type !== form.railcard}" class="btn d-block mx-auto mt-2 w-50 py-3 railcard-btn">
                                    <strong>{{ type }}</strong>
                                </button>
                            </div>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { BModal } from 'bootstrap-vue';

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'Home',
    props: ['form'],
    components: {
        BModal,
    },
    data() {
        return {
            brand: whitelabel.brand,
            railcardOptions: {
                '16-17': '16-17 Saver',
                '16-25': '16-25 Railcard',
                '26-30': '26-30 Railcard',
                'disabled-person': 'Disabled Persons Railcard',
                senior: 'Senior Railcard',
            },
            modalShow: false,
            acceptTermsCheckbox: false,
            acceptTermsCheckboxError: false,
            disabledDates: {
                to: new Date(Date.now() - 8640000),
                from: new Date(Date.now() + (100000000 * 30 * 4.5)),
            },
            inputFocused: false,
        }
    },

    mounted() {
        this.form.has_concessionary_pass = this.hasConcessionaryPass
        this.form.has_car_access = this.hasAccessToCar
        this.form.railcard = this.railcardType
    },
    methods: {
        toggleHasRailCard() {
            this.form.has_railcard = !this.form.has_railcard
            if (this.form.has_railcard) {
                this.$refs['railcard-modal'].show()
            } else {
                this.form.railcard = ''
                this.form.has_railcard = false
            }
        },
        changeRailcard() {
            this.$refs['railcard-modal'].show()
        },
        hideModal() {
            this.$refs['railcard-modal'].hide()
        },
        selectRailcardType(index) {
            this.form.railcard = this.railcardOptions[index]
            this.$refs['railcard-modal'].hide()
        },
        onFocus(field) {
            this.setError({
                field,
                error: false,
            })
        },
        onModalClose() {
            if (!this.form.railcard) {
                this.form.has_railcard = false
            }
        },
    },
}

</script>
